/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Autonomoustriggerdetectordefect3Inputs */



/**
* | output |
* | --- |
* | "ATD fault" |
*
* @param {Ahu_History_Key_Autonomoustriggerdetectordefect3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_autonomoustriggerdetectordefect3 = /** @type {((inputs?: Ahu_History_Key_Autonomoustriggerdetectordefect3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Autonomoustriggerdetectordefect3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("ATD fault")
	return /** @type {LocalizedString} */ ("Défaut DAD")
});
export { ahu_history_key_autonomoustriggerdetectordefect3 as "ahu_history_key_autonomousTriggerDetectorDefect" }